// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"9aaf6519","119":"854fd754","379":"338dd2e9","501":"02f05ca6","545":"e463079a","645":"cf47f4a3","689":"e8a3a7c8","758":"62941cc8"}[chunkId] + ".chunk.js";
};